import React, { Component } from "react";
import { connect } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import patterns from  "../constants/patterns";
import surfaces from  "../constants/surfaces";
//import AdminResource from "./AdminResource";
import convertTimestampToDate from "../utils/convertTimestampToDate";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";


const EXPORT_ATTRS = {
  users: ["email", "activity", "gender", "firstname", "lastname", "company", "address", "postalCode", "city", "country"],
  folders: ["id", "title"],
  models: ["id", "userId", "folderId"],
}


class Admin extends Component {
  state = {
    type: null,
    resource: null,
    currentTab: 0
  }

  constructor(props) {
    super(props);

    this.handleResourceClick = this.handleResourceClick.bind(this);
    this.handleExportCSV = this.handleExportCSV.bind(this);
  }

  handleResourceClick(type, resource) {
    this.setState({ type, resource });
  }

  exportCSV(resource, collection) {
    const attrs = EXPORT_ATTRS[resource];
    const today = new Date();
    const timestamp = today.toISOString().substring(0, 10);
    const header = attrs.map(attr => `"${attr}"`).join(";");

    const content = collection.map(entry => {
      return attrs.map(attr => `"${entry[attr]}"`).join(";")
    });

    const csv = [header, ...content].join("\n")
    const csvData = new Blob([csv], { type: "text/csv" });
    const csvUrl = URL.createObjectURL(csvData);
    const a = document.createElement('a');

    a.download = `${timestamp}-${resource}.csv`;
    a.href = csvUrl;
    a.dataset.downloadurl = ["text/csv", a.download, a.href].join(':');
    a.style = "visibility:hidden";

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  handleExportCSV(resource) {
    this.exportCSV(resource, this.props.adminResources[resource]);
  }

  render() {
    const { users, folders, models } = this.props.adminResources;
    const { resource } = this.state;
    const today = new Date();
    const timestamp = today.toISOString().substring(0, 10);

    return (
      <div className="header-push admin">
        <div className="admin__index">

          <Tabs className="admin__tabs">
            <TabList>
              <Tab>Vue d'ensemble (au {timestamp})</Tab>
              <Tab>Utilisateurs ({users && users.length})</Tab>
              <Tab>Dossiers enregistrés ({folders && folders.length})</Tab>
              <Tab>Modèles enregistrés ({models && models.length})</Tab>
              <Tab>Surfaces enregistrées</Tab>
              <Tab>Motifs enregistrés</Tab>
            </TabList>

            <TabPanel>
                <div>
                {this.props.adminResources["users"] && this.props.adminResources["users"].map(user => (
                  <div key={`us-${user.id}`} className="admin__userlist">
                    <hr/>
                      Adresse E-mail : <h1>{user.email}</h1><br/>
                      Utilisateur ID : <b>{user.id}</b><br/>
                      First Name : <b>{user.firstname}</b><br/>
                      Last Name : <b>{user.lastname}</b><br/>
                      Company : <b>{user.company}</b><br/>
                      Address : <b>{user.address}</b><br/>
                      Postal Code : <b>{user.postalCode}</b><br/>
                      City : <b>{user.city}</b><br/>
                      Country : <b>{user.country}</b><br/>
                      Inscrit le : <b>{convertTimestampToDate(user.createdAt)}</b>

                    {this.props.adminResources["folders"] && this.props.adminResources["folders"].map(folder => (folder.userId === user.id &&
                      <div key={`user-folder-${folder.id}`}>
                        <br/>
                        Nom du dossier : <b>"{folder.title}" ({this.props.adminResources["models"].filter(model => (model.userId === user.id && folder.id === model.folderId)).length} modèles enregistrés)</b>
                        {this.props.adminResources["models"] && this.props.adminResources["models"].map(model => (model.userId === user.id && folder.id === model.folderId && model.surfaceId &&
                          <div>Modèle enregistré : "Surface : {model.surfaceId} - <b>{surfacesByIds[model.surfaceId] && surfacesByIds[model.surfaceId].title}</b> / Motif : <b>{patternsByIds[model.patternId] && patternsByIds[model.patternId].title}"</b><br/></div>))}
                      </div>))}
                </div>
                ))}
              </div>
            </TabPanel>

            <TabPanel>
              <div className="admin__csv" onClick={() => this.handleExportCSV("users")}>
                Export CSV
              </div>
            {/*              <div className="admin__list"> */}
              <div>
                <table border="1"><tbody>
                <tr>
                  <td><b>Utilisateur ID</b></td>
                  <td><b>Adresse E-mail</b></td>
                  <td><b>First Name</b></td>
                  <td><b>Last Name</b></td>
                  <td><b>Company</b></td>
                  <td><b>Address</b></td>
                  <td style={{ whiteSpace: 'pre-wrap' }}><b>Postal Code</b></td>
                  <td><b>City</b></td>
                  <td><b>Country</b></td>
                </tr>

                {this.props.adminResources["users"] && this.props.adminResources["users"].map(user => (
                  <tr key={`ap-${user.id}`}>
                    <td>
                    <div
                    style={{ color: resource && resource.id === user.id ? "blue" : "black"}}
                    key={user.id}
                    /*onClick={() => this.handleResourceClick("user", user)}*/
                  >
                    {user.id}</div>
                    </td>
                    <td>{user.email}</td>
                    <td>{user.firstname}</td>
                    <td>{user.lastname}</td>
                    <td>{user.company}</td>
                    <td>{user.address}</td>
                    <td>{user.postalCode}</td>
                    <td>{user.city}</td>
                    <td>{user.country}
                    </td>
                  </tr>
                ))}

                </tbody></table>
              </div>
            </TabPanel>

            <TabPanel>
            {/*
              <div className="admin__csv" onClick={() => this.handleExportCSV("folders")}>
                Export CSV
              </div>
            */}

{/*              <div className="admin__list"> */}
                <div>

                <div className="admin__list-item">
                  <div className="admin__id"><b>Dossier ID :</b></div>
                  <div className="admin__id"><b>Nom du dossier :</b></div>
                  <div className="admin__id"><b>Créé le :</b></div>
                  <div className="admin__id"><b>Dernière modification :</b></div>
                </div>

                {folders && folders.map(folder => (
                  <div
                    className="admin__list-item"
                    style={{ color: resource && resource.id === folder.id ? "blue" : "black"}}
                    key={folder.id}
                    /*onClick={() => this.handleResourceClick("folder", folder)}*/
                  >
                    <div className="admin__id">{folder.id}</div>
                    <div className="admin__id">{folder.title}</div>
                    <div className="admin__id">{convertTimestampToDate(folder.createdAt)}</div>
                    <div className="admin__id">{convertTimestampToDate(folder.updatedAt)}</div>
                  </div>
                ))}
              </div>
            </TabPanel>

            <TabPanel>
            {/*
              <div className="admin__csv" onClick={() => this.handleExportCSV("models")}>
                Export CSV
              </div>
            */}

                <div>
                <div className="admin__list-item">
                  <div className="admin__id"><b>Modèle ID :</b></div>
                  <div className="admin__large"><b>Composition du modèle :</b></div>
                  <div className="admin__id"><b>Créé le :</b></div>
                  <div className="admin__id"><b>Dernière modification :</b></div>
                </div>

                {models && models.map(model => (
                  <div
                    className="admin__list-item"
                    style={{ color: resource && resource.id === model.id ? "blue" : "black"}}
                    key={model.id}
                    /*onClick={() => this.handleResourceClick("model", model)}*/
                  >
                    <div className="admin__id">{model.id}</div>
                    <div className="admin__large">
                      {resource && resource.id === model.id ? resource.id : model.id}
                      {" / "}
                      {surfacesByIds[model.surfaceId] && surfacesByIds[model.surfaceId].id} {surfacesByIds[model.surfaceId] && surfacesByIds[model.surfaceId].title}
                      {" / "}
                      {surfacesByIds[model.patternId] && patternsByIds[model.patternId].title}
                    </div>
                    <div className="admin__id">{convertTimestampToDate(model.createdAt)}</div>
                    <div className="admin__id">{convertTimestampToDate(model.updatedAt)}</div>
                  </div>
                ))}
              </div>
            </TabPanel>

            <TabPanel>
            {/*
              <div className="admin__csv" onClick={() => this.handleExportCSV("models")}>
                Export CSV
              </div>
            */}

                <div>
                <div className="admin__list-item">
                  <div><b>Nombre de surfaces enregistrées :</b></div>
                </div>
                {surfaces && surfaces.map(surface => (
                      <div key={surface.id} className={(models && models.filter(model => (model.surfaceId === surface.id)).length) > 0 && "admin__list-item-bold"}>
                      {surface.title} ({(models && models.filter(model => (model.surfaceId === surface.id)).length)} modèles enregistrés)
                    </div>
                ))}
{/* }({this.props.adminResources["models"].filter(model => (model.surfaceId === surface.id)).length} modèles enregistrés)  */}
              </div>
            </TabPanel>


            <TabPanel>
            {/*
              <div className="admin__csv" onClick={() => this.handleExportCSV("models")}>
                Export CSV
              </div>
            */}

                <div>
                <div className="admin__list-item">
                  <div><b>Nombre de motifs enregistrés :</b></div>
                </div>
                {patterns && patterns.map(pattern => (
                  <div key={pattern.id} className={(models && models.filter(model => (model.patternId === pattern.id)).length) > 0 && "admin__list-item-bold"}>
                    {pattern.title} ({(models && models.filter(model => (model.patternId === pattern.id)).length)} modèles enregistrés)
                  </div>
                ))}
              </div>
            </TabPanel>

          </Tabs>
        </div>
        {/*
          <div className="admin__show">
          <div className="admin__sticky">
            <AdminResource {...this.state} />
          </div>
        </div>
        */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  adminResources: state.user.adminResources || {}
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js